import { IAuditEntityData } from "src/app/core/interfaces/iaudit-entity-data";
import { EntityUtilsService } from "src/app/core/utils/entity-utils.service";
import { LTSAEvergreen } from "../../constants";
import { ContactsDisplay } from "../../contact/display/contacts-display";
import { EntityName } from "../../enumerations/entity-name";
import { OperationType } from "../../enumerations/operation-type";
import { PipelinesLTSA } from "../save/pipelines-ltsa";
import { AssetsPipesAssociatedDisplay } from "./assets-pipes-associated-display";
import { PipelinesLTSAContactInfoDisplay } from "./pipelines-ltsa-contact-info-display";
import { PipelinesLTSASubTypesDisplay } from "./pipelines-ltsa-sub-types-display";
import { PipelinesLTSATradesDisplay } from "./pipelines-ltsa-trades-display";
import { PipelinesLTSATypesDisplay } from "./pipelines-ltsa-types-display";

export class PipelinesLTSADisplay extends PipelinesLTSA {
    pipelineName: string;
    companyName: string;
    pipelineOwner: string;
    mailAddressV1: string;
    mailAddressV2: string;
    mailCountry: string;
    mailCountryName: string;
    mailState: string;
    mailStateName: string;
    mailCity: string;
    mailPostalCode: string;
    phoneCc: string;
    phoneNo: string;
    phoneExt: string;
    lastUserEmailAddress: string;
    entryUserEmailAddress: string;
    previousUserEmailAddress: string;
    qcUserEmailAddress: string;
    releaseUserEmailAddress: string;
    amendmentUserEmailAddress: string;
    mailCountryId: number | null;
    mailStateId: number | null;
    mailCityId: number | null;

    evergreenBool: boolean;
    preferredContractorBool: boolean;

    commentsQcSelected: boolean;
    commentsQcLastDate: string;
    commentsQcLastUser: string;
    commentsQcPrevDate: string;
    commentsQcPrevUser: string;

    pipelinesLtsaContactInfoDisplay: Array<PipelinesLTSAContactInfoDisplay>;
    pipelinesLtsaTypesDisplay: Array<PipelinesLTSATypesDisplay>;
    pipelinesLtsaSubTypesDisplay: Array<PipelinesLTSASubTypesDisplay>;
    pipelinesLtsaTradesDisplay: Array<PipelinesLTSATradesDisplay>;
    assetsPipesAssociatedDisplay: Array<AssetsPipesAssociatedDisplay>;
    contactsDisplays: Array<ContactsDisplay>;

    private constructor(entity?: any) {
        super(entity);
        this.pipelineName = entity?.pipelineName ?? '';
        this.companyName = entity?.companyName ?? '';
        this.pipelineOwner = entity?.pipelineOwner ?? '';
        this.mailAddressV1 = entity?.mailAddressV1 ?? '';
        this.mailAddressV2 = entity?.mailAddressV2 ?? '';
        this.mailCountry = entity?.mailCountry ?? '';
        this.mailCountryName = entity?.mailCountryName ?? '';
        this.mailState = entity?.mailState ?? '';
        this.mailStateName = entity?.mailStateName ?? '';
        this.mailCity = entity?.mailCity ?? '';
        this.mailPostalCode = entity?.mailPostalCode ?? '';
        this.phoneCc = entity?.phoneCc ?? '';
        this.phoneNo = entity?.phoneNo ?? '';
        this.phoneExt = entity?.phoneExt ?? '';
        this.lastUserEmailAddress = entity?.lastUserEmailAddress ?? '';
        this.entryUserEmailAddress = entity?.entryUserEmailAddress ?? '';
        this.previousUserEmailAddress = entity?.previousUserEmailAddress ?? '';
        this.qcUserEmailAddress = entity?.qcUserEmailAddress ?? '';
        this.releaseUserEmailAddress = entity?.releaseUserEmailAddress ?? '';
        this.amendmentUserEmailAddress = entity?.amendmentUserEmailAddress ?? '';
        this.mailCountryId = entity?.mailCountryId ?? null;
        this.mailStateId = entity?.mailStateId ?? null;
        this.mailCityId = entity?.mailCityId ?? null;

        this.preferredContractorBool = Number(this.preferredContractor) === 1;
        this.evergreenBool = Number(this.contractLength) === LTSAEvergreen.Code;

        this.commentsQcSelected = entity?.commentsQcSelected ?? false;
        this.commentsQcLastDate = entity?.commentsQcLastDate ?? null;
        this.commentsQcLastUser = entity?.commentsQcLastUser ?? null;
        this.commentsQcPrevDate = entity?.commentsQcPrevDate ?? null;
        this.commentsQcPrevUser = entity?.commentsQcPrevUser ?? null;

        this.pipelinesLtsaContactInfoDisplay = entity?.pipelinesLtsaContactInfoDisplay ?? [];
        this.pipelinesLtsaTypesDisplay = entity?.pipelinesLtsaTypesDisplay ?? [];
        this.pipelinesLtsaSubTypesDisplay = entity?.pipelinesLtsaSubTypesDisplay ?? [];
        this.pipelinesLtsaTradesDisplay = entity?.pipelinesLtsaTradesDisplay ?? [];
        this.assetsPipesAssociatedDisplay = entity?.assetsPipesAssociatedDisplay ?? [];
        this.contactsDisplays = entity?.contactsDisplays ?? [];
    }

    static BuildPipelineLTSADisplay(entity: any): PipelinesLTSADisplay {
        entity = EntityUtilsService.convertUTCDates(entity);
        return new PipelinesLTSADisplay(entity);
    }

    static BuildNewPipelineLTSA(response: any): PipelinesLTSADisplay {
        return new PipelinesLTSADisplay({
            pipelineLtsaId: response[0].PIPE_LTSA_ID,
            operation: OperationType.INSERT,
            intDataDepValState: OperationType.INSERT
        });
    }

    get auditEntityBean(): IAuditEntityData {
        return {
            lastUser: this.lastUser,
            entryUser: this.entryUser,
            prevUser: this.prevUser,
            qcUser: this.qcUser,
            lastDate: this.lastDate,
            entryDate: this.entryDate,
            prevDate: this.prevDate,
            qcDate: this.qcDate,
            releaseUser: this.releaseUser,
            releaseDate: this.releaseDate,
            amendmentUser: this.amendmentUser,
            amendmentDate: this.amendmentDate,
            lastUserEmailAddress: this.lastUserEmailAddress,
            entryUserEmailAddress: this.entryUserEmailAddress,
            previousUserEmailAddress: this.previousUserEmailAddress,
            qcUserEmailAddress: this.qcUserEmailAddress,
            releaseUserEmailAddress: this.releaseUserEmailAddress,
            amendmentUserEmailAddress: this.amendmentUserEmailAddress,
            lastUpdateStatus: '',
            entityName: EntityName.PIPELINE_LTSA,
            entityId: this.pipelineLtsaId
        };
    }

    prepareSaveCollection() {
        this.pipelinesLtsaContactInfo = this.pipelinesLtsaContactInfoDisplay;
        this.pipelinesLtsaTypes = this.pipelinesLtsaTypesDisplay;
        this.pipelinesLtsaSubTypes = this.pipelinesLtsaSubTypesDisplay;
        this.pipelinesLtsaTrades = this.pipelinesLtsaTradesDisplay;
        this.assetsPipesAssociated = this.assetsPipesAssociatedDisplay;
        this.contacts = this.contactsDisplays;
    }

    getLtsaName(): string {
        return this.assetsPipesAssociatedDisplay.find(pipe => pipe.mvOrder === 1 &&
            pipe.getOperation && pipe.getOperation() !== OperationType.DELETE)?.assetName ?? '';
    }

}
